$(document).ready(function () {
    var selectedUrl = '';
    var defaultCountryUrl = ''; // Variable to store the default URL from the href
    var isLanguageSelected = false; // Track if a language is selected

    $('.selected-country').click(function () {
        $('.country-list').toggle();
    });

    $('.country-list li').click(function () {
        var selectedCountry = $(this).data('country');
        selectedUrl = '';
        $('.selected-country').text(selectedCountry);
        $('.country-list').hide();
        $('.country-list li').removeClass('selected');
        $(this).addClass('selected');

        // Populate the form fields based on the selected country
        populateForm(selectedCountry);
    });

    $('#confirmcountry').click(function () {
        if (!selectedUrl && defaultCountryUrl) {
            selectedUrl = defaultCountryUrl; // Use the default URL if no specific URL is selected
        }
        if (selectedUrl) {
            window.location.href = selectedUrl; // Navigate to the selected URL when the button is clicked
        } else {
            location.reload(); // Reload the page if nothing is selected
        }
    });

    // Close the dropdown if the user clicks outside of it
    $(document).click(function (event) {
        if (!$(event.target).closest('.slct-y-container').length) {
            $('.country-list').hide();
        }
    });

    function populateForm(country) {
        var data = subReasons[country] || [];
        var countryLink = $(`.hidden_select a[data-country="${country}"]`);
        defaultCountryUrl = countryLink.attr('href'); // Get the default URL from href

        // Clear existing language and currency options
        $('.lang-select').empty();
        $('.p--crncy').empty();

        // Append the Language label only once
        let languageHtml = '';
        let hasLanguages = false;
        let singleLanguageChecked = false;

        data.forEach(function (item) {
            if (item.Language) {
                var inputId = 'locale-' + item.Language.replace(/\s+/g, '_').toLowerCase();
                var checked = item.Language.toLowerCase() === 'english' ? 'checked' : ''; // Default check if English
                if (!singleLanguageChecked) {
                    checked = 'checked'; // Check the radio button if it's the only language
                    singleLanguageChecked = true;
                }
                languageHtml += `
                    <div class="form-cstm-control">
                        <input value="${item.Language}" type="radio" class="input-dyc" id="${inputId}" name="language" ${checked} data-url="${item.url}">
                        <label class="custom-lbl" for="${inputId}">
                            ${item.text}
                        </label>
                    </div>
                `;
                hasLanguages = true;
            }

            if (item.money) {
                // Update currency
                $('.p--crncy').html(`
                    <label class="curren-ttl-i1 lang-lbl">Currency</label>
                    <p class="crs-mny">${item.text}</p>
                `);
            }
        });

        if (hasLanguages) {
            // Append the Language label and options only if there are languages
            $('.lang-select').append(`
                <label class="lang-ttl-i1 lang-lbl">Language</label>
                ${languageHtml}
            `);

            // Attach click event to radio buttons to update the selected URL
            $('.input-dyc').click(function () {
                isLanguageSelected = true; // Set the flag when a language is selected
                selectedUrl = $(this).data('url');
            });
        }

        // Hide sections if no data is available
        if ($('.lang-select').is(':empty')) {
            $('.lang-select').hide();
        } else {
            $('.lang-select').show();
        }

        if ($('.p--crncy').is(':empty')) {
            $('.p--crncy').hide();
        } else {
            $('.p--crncy').show();
        }
    }

    const subReasons = {
        "Belgium": [
            { "Language": "FRANÇAIS", "text": "FRANÇAIS", "url": "https://be.maje.com/" },
            { "Language": "ENGLISH", "text": "ENGLISH", "url": "https://be.maje.com/en/home/" },
            { "money": "CURRENCY", "text": "€ - EURO" }
        ],
        "Canada": [
            { "Language": "ENGLISH", "text": "ENGLISH", "url": "https://ca.maje.com/" },
            { "Language": "FRANÇAIS", "text": "FRANÇAIS", "url": "https://ca.maje.com/fr/home" },
            { "money": "CURRENCY", "text": "C$ - CANADIAN DOLLAR" }
        ],
        "Spain": [
            { "Language": "ESPAÑOL", "text": "ESPAÑOL", "url": "https://es.maje.com/" },
            { "money": "CURRENCY", "text": "€ - EURO" }
        ],
        "United States": [
            { "Language": "ENGLISH", "text": "ENGLISH", "url": "https://us.maje.com/" },
            { "money": "CURRENCY", "text": "$ - US DOLLAR" }
        ],
        "Europe": [
            { "Language": "ENGLISH", "text": "ENGLISH", "url": "https://eu.maje.com/" },
            { "money": "CURRENCY", "text": "€ - EURO" }
        ],
        "France": [
            { "Language": "FRANÇAIS", "text": "FRANÇAIS", "url": "https://fr.maje.com/" },
            { "money": "CURRENCY", "text": "€ - EURO" }
        ],
        "Germany": [
            { "Language": "DEUTSCH", "text": "DEUTSCH", "url": "https://de.maje.com/" },
            { "money": "CURRENCY", "text": "€ - EURO" }
        ],
        "Ireland": [
            { "Language": "ENGLISH", "text": "ENGLISH", "url": "https://ie.maje.com/" },
            { "money": "CURRENCY", "text": "€ - EURO" }
        ],
        "Italy": [
            { "Language": "ITALIANO", "text": "ITALIANO", "url": "https://it.maje.com/" },
            { "money": "CURRENCY", "text": "€ - EURO" }
        ],
        "United Kingdom": [
            { "Language": "ENGLISH", "text": "ENGLISH", "url": "https://uk.maje.com/" },
            { "money": "CURRENCY", "text": "£ - POUND STERLING" }
        ],
        "Switzerland": [
            { "Language": "ENGLISH", "text": "ENGLISH", "url": "https://ch.maje.com/" },
            { "money": "CURRENCY", "text": "CHF - SWISS FRANC" }
        ]
    };
});
// language drawer open
document.addEventListener('DOMContentLoaded', function () {
    var opnDrawers = document.querySelectorAll('[data-action="locale-drawer"]');
    var rightSidePopUp = document.querySelector('.right-side-pop-up');
    var closeDrawers = document.querySelectorAll('.close-drawer');

    function toggleBodyScroll(isOpen) {
        document.body.classList.toggle('no-scroll', isOpen);
        // document.body.classList.toggle('header-white', isOpen);
        if (!document.body.classList.contains('header-white')) {
            document.body.classList.toggle('header-white', isOpen);
        }
    }
    if (opnDrawers && rightSidePopUp) {
        opnDrawers.forEach(function (opnDrawer) {
            opnDrawer.addEventListener('click', function (event) {
                event.preventDefault();
                var isOpen = rightSidePopUp.classList.toggle('open');
                toggleBodyScroll(isOpen);
            });
        });
    }
    closeDrawers.forEach(function (closeDrawer) {
        closeDrawer.addEventListener('click', function () {
            if (rightSidePopUp) {
                rightSidePopUp.classList.remove('open');
                toggleBodyScroll(false);
            }
        });
    });
    document.addEventListener('click', function (event) {
        if (!rightSidePopUp.contains(event.target) && ![...opnDrawers].some(opnDrawer => opnDrawer.contains(event.target))) {
            rightSidePopUp.classList.remove('open');
            toggleBodyScroll(false);
        }
    });
});
// PDP Drawer
document.addEventListener('DOMContentLoaded', function () {

    var descDrwElements = document.querySelectorAll('.desc-drw');
    var rightSideDescription = null;

    var closeDrawerButtons = document.querySelectorAll('.close-desc-drawer');
    var prevButton = document.querySelector('.prev-a');
    var nextButton = document.querySelector('.next-a');
    var prevTitleSpan = document.querySelector('.prev-ttl');
    var nextTitleSpan = document.querySelector('.next-ttl');

    function toggleBodyScroll(isOpen) {
        document.body.classList.toggle('disable-scroll', isOpen);
    }

    function updateActiveDrawer(targetId, drawer) {

        if (!drawer) return;

        rightSideDescription = drawer;

        var targetContent = drawer.querySelector('#' + targetId);

        drawer.querySelectorAll('.drawer-p-description').forEach(function (content) {
            content.classList.remove('active');
        });

        if (targetContent) {
            targetContent.classList.add('active');
        }

        drawer.classList.add('open-drawer');
        toggleBodyScroll(true);

        updateNavigationTitles();
    }

    function getCurrentIndex() {

        if (!rightSideDescription) return -1;

        var activeElement = rightSideDescription.querySelector('.drawer-p-description.active');

        return Array.from(
            rightSideDescription.querySelectorAll('.drawer-p-description')
        ).indexOf(activeElement);
    }

    function getElementByIndex(index) {

        if (!rightSideDescription) return null;

        return rightSideDescription.querySelectorAll('.drawer-p-description')[index];
    }

    function getTitleByIndex(index) {

        var element = getElementByIndex(index);

        return element
            ? element.querySelector('.drawer-name').textContent.trim()
            : '';
    }

    function updateNavigationTitles() {

        if (!rightSideDescription) return;

        var currentIndex = getCurrentIndex();

        var totalElements =
            rightSideDescription.querySelectorAll('.drawer-p-description').length;

        var prevIndex = currentIndex > 0 ? currentIndex - 1 : null;
        var nextIndex = currentIndex < totalElements - 1 ? currentIndex + 1 : null;

        if (prevTitleSpan)
            prevTitleSpan.textContent =
                prevIndex !== null ? getTitleByIndex(prevIndex) : '';

        if (nextTitleSpan)
            nextTitleSpan.textContent =
                nextIndex !== null ? getTitleByIndex(nextIndex) : '';

        if (prevButton)
            prevButton.style.display =
                prevIndex !== null ? 'flex' : 'none';

        if (nextButton)
            nextButton.style.display =
                nextIndex !== null ? 'flex' : 'none';
    }

        document.addEventListener('click', function (event) {

            var element = event.target.closest('.desc-drw');

            if (!element) return;

            event.preventDefault();

            var targetId = element.dataset.id;
            var drawer = document.querySelector(element.dataset.target);

            updateActiveDrawer(targetId, drawer);

        });
        // Close drawer
    if (closeDrawerButtons.length > 0) {

        closeDrawerButtons.forEach(function (button) {

            button.addEventListener('click', function () {

                if (!rightSideDescription) return;

                rightSideDescription.classList.remove('open-drawer');

                rightSideDescription
                    .querySelectorAll('.drawer-p-description')
                    .forEach(function (content) {
                        content.classList.remove('active');
                    });

                toggleBodyScroll(false);

            });

        });

    }


    // Close drawer by clicking overlay
    document.addEventListener('click', function (event) {

        if (
            rightSideDescription &&
            rightSideDescription.classList.contains('open-drawer') &&
            event.target.classList.contains('custom-drawer__overlay')
        ) {

            rightSideDescription.classList.remove('open-drawer');

            rightSideDescription
                .querySelectorAll('.drawer-p-description')
                .forEach(function (content) {
                    content.classList.remove('active');
                });

            toggleBodyScroll(false);
        }

    });


    // Previous button
    if (prevButton) {

        prevButton.addEventListener('click', function () {

            var currentIndex = getCurrentIndex();

            if (currentIndex > 0) {

                var previousContent = getElementByIndex(currentIndex - 1);

                rightSideDescription
                    .querySelectorAll('.drawer-p-description')
                    .forEach(function (content) {
                        content.classList.remove('active');
                    });

                previousContent.classList.add('active');

                updateNavigationTitles();
            }

        });

    }


    // Next button
    if (nextButton) {

        nextButton.addEventListener('click', function () {

            var currentIndex = getCurrentIndex();

            var total =
                rightSideDescription.querySelectorAll('.drawer-p-description').length;


            if (currentIndex < total - 1) {

                var nextContent = getElementByIndex(currentIndex + 1);

                rightSideDescription
                    .querySelectorAll('.drawer-p-description')
                    .forEach(function (content) {
                        content.classList.remove('active');
                    });

                nextContent.classList.add('active');

                updateNavigationTitles();
            }

        });

    }


    // ESC key close drawer
    document.addEventListener('keydown', function (event) {

        if (event.key === 'Escape') {

            if (
                rightSideDescription &&
                rightSideDescription.classList.contains('open-drawer')
            ) {

                rightSideDescription.classList.remove('open-drawer');

                rightSideDescription
                    .querySelectorAll('.drawer-p-description')
                    .forEach(function (content) {
                        content.classList.remove('active');
                    });

                toggleBodyScroll(false);

            }

        }

    });

});
document.addEventListener('DOMContentLoaded', function () {
    var opnDrawers = document.querySelectorAll('[data-action="account-drawer"]');
    var sizeguidePopup = document.querySelector('.right-side-account-drawer');
    var closeDrawers = document.querySelectorAll('.close-sg-drawer');

    function toggleBodyScroll(isOpen) {
        document.body.classList.toggle('dont-scroll', isOpen);
    }

    if (sizeguidePopup) {
        if (opnDrawers.length > 0) {
            opnDrawers.forEach(function (opnDrawer) {
                opnDrawer.addEventListener('click', function (event) {
                    event.preventDefault();
                    if (opnDrawer.classList.contains('header_drawer-dd')) {
                        document.querySelector('#close-menu-drawer').click();
                    }
                    var isOpen = sizeguidePopup.classList.toggle('open');
                    toggleBodyScroll(isOpen);
                });
            });
        }

        if (closeDrawers.length > 0) {
            closeDrawers.forEach(function (closeDrawer) {
                closeDrawer.addEventListener('click', function () {
                    sizeguidePopup.classList.remove('open');
                    toggleBodyScroll(false);
                });
            });
        }

        document.addEventListener('click', function (event) {
            if (!sizeguidePopup.contains(event.target) && ![...opnDrawers].some(opnDrawer => opnDrawer.contains(event.target))) {
                sizeguidePopup.classList.remove('open');
                toggleBodyScroll(false);
            }
        });
    }
});
document.addEventListener('DOMContentLoaded', function () {
    const drawerButton = document.getElementById('ca-drawer');
    const drawer = document.querySelector('.ac--inner-drawer');
    const templateElement = document.getElementById('template');

    if (drawerButton && drawer && templateElement) {
        drawerButton.addEventListener('click', function () {
            drawer.classList.add('open');

            const backButton = drawer.querySelector('.back-prev-pg');
            if (backButton) {
                backButton.addEventListener('click', function () {
                    // Remove the 'open' class to close the drawer
                    drawer.classList.remove('open');
                });
            }
        });
    }
});

document.addEventListener('DOMContentLoaded', function () {
    const forgotPasswordLink = document.querySelector('.frgt-password');
    const backButtons = document.querySelectorAll('.back-pg-btn');
    const drawer = document.querySelector('.recover-yr-psw-drawer');

    if (forgotPasswordLink) {
        forgotPasswordLink.addEventListener('click', function (event) {
            event.preventDefault();
            if (drawer) {
                drawer.classList.add('open');
            }
        });
    }

    if (backButtons.length > 0) {
        backButtons.forEach(function (button) {
            button.addEventListener('click', function () {

                const closestDrawer = this.closest('.recover-yr-psw-drawer');
                if (closestDrawer) {
                    closestDrawer.classList.remove('open');
                }
            });
        });
    }
});
const anchors = document.querySelectorAll('.full-look-anchor');

if (anchors.length > 0) {
    anchors.forEach(function (anchor) {
        anchor.addEventListener('click', function (e) {
            e.preventDefault();
            const target = document.querySelector(this.getAttribute('data-anchor'));
            if (target) {
                target.scrollIntoView({
                    behavior: 'smooth'
                });
            }
        });
    });
}

let lastHeight = window.innerHeight;
let heightUpdateTimer;
function updateDeviceHeight() {
    clearTimeout(heightUpdateTimer);
    heightUpdateTimer = setTimeout(() => {
        const activeElement = document.activeElement;
        const isInputFocused = activeElement && ['INPUT', 'TEXTAREA', 'SELECT'].includes(activeElement.tagName);
        if (isInputFocused) return;

        let currentHeight = window.visualViewport ? window.visualViewport.height : window.innerHeight;
        // Only update if height changed significantly to avoid jumpiness during scroll
        if (Math.abs(lastHeight - currentHeight) > 10) {
            lastHeight = currentHeight;
            document.documentElement.style.setProperty('--window-inner-height', `${currentHeight}px`);
        }
    }, 150);
}
window.addEventListener('resize', updateDeviceHeight);
// window.addEventListener('orientationchange', () => {
//     updateDeviceHeight();
// });
if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', updateDeviceHeight);
}
document.documentElement.style.setProperty('--window-inner-height', `${window.visualViewport ? window.visualViewport.height : window.innerHeight}px`);
